import { useMemo } from 'react';

import { DataTable, type TableColumn } from '@/src/ui';
import type { StudentDTO } from '../TeacherDashboardDTOs';
import { ReportHeaderStyle, ReportCellStyle } from '@/src/utils';

interface StudentsTableProps {
    data: Array<StudentDTO>;
}

export default function StudentsTable(props: StudentsTableProps) {
    const { data } = props;

    const columns = useMemo<TableColumn[]>(() => {
        if (!data || data.length === 0) return [];
        const cols: TableColumn[] = [
            {
                dataKey: 'name',
                header: 'Name',
                align: 'left',
                allowSort: true,
                emptyValue: '-',
                headerSx: ReportHeaderStyle,
                cellSx: ReportCellStyle,
                formatter: (row: StudentDTO) => `${row.fName} ${row.lName}`,
            },
            {
                dataKey: 'username',
                header: 'Username',
                align: 'left',
                allowSort: true,
                emptyValue: '-',
                headerSx: ReportHeaderStyle,
                cellSx: ReportCellStyle,
            },
            {
                dataKey: 'grade',
                header: 'Grade',
                align: 'left',
                allowSort: true,
                emptyValue: '-',
                headerSx: ReportHeaderStyle,
                cellSx: ReportCellStyle,
            },
        ];
        return cols;
    }, [data]);

    return (
        <DataTable
            columns={columns}
            data={data}
            tableName="Students"
            rowsPerPageInitial={5}
            rowsPerPageList={[5]}
            alternatingRowColor
            defaultSortColumn="name"
            defaultSortDirection="asc"
        />
    );
}
